// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActFormController from "./act_form_controller"
application.register("act-form", ActFormController)

import ActItemsController from "./act_items_controller"
application.register("act-items", ActItemsController)

import AnimalBlockController from "./animal_block_controller"
application.register("animal-block", AnimalBlockController)

import AnimalConditionFormController from "./animal_condition_form_controller"
application.register("animal-condition-form", AnimalConditionFormController)

import AnimalItemSearchSvelteController from "./animal_item_search_svelte_controller"
application.register("animal-item-search-svelte", AnimalItemSearchSvelteController)

import BlockedEventAssignationController from "./blocked_event_assignation_controller"
application.register("blocked-event-assignation", BlockedEventAssignationController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CalendarGridController from "./calendar_grid_controller"
application.register("calendar-grid", CalendarGridController)

import CalendarMessagesAssignationController from "./calendar_messages_assignation_controller"
application.register("calendar-messages-assignation", CalendarMessagesAssignationController)

import CalendarNavigateController from "./calendar_navigate_controller"
application.register("calendar-navigate", CalendarNavigateController)

import ClientAnimalsController from "./client_animals_controller"
application.register("client-animals", ClientAnimalsController)

import ClientFormController from "./client_form_controller"
application.register("client-form", ClientFormController)

import ClinicVetController from "./clinic_vet_controller"
application.register("clinic-vet", ClinicVetController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import ConsultationFormSvelteController from "./consultation_form_svelte_controller"
application.register("consultation-form-svelte", ConsultationFormSvelteController)

import ConsultationNotesController from "./consultation_notes_controller"
application.register("consultation-notes", ConsultationNotesController)

import ConsultationTextsSvelteController from "./consultation_texts_svelte_controller"
application.register("consultation-texts-svelte", ConsultationTextsSvelteController)

import CreditNoteFormController from "./credit_note_form_controller"
application.register("credit-note-form", CreditNoteFormController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DayMonthSelectController from "./day_month_select_controller"
application.register("day-month-select", DayMonthSelectController)

import DownloadFileLinkController from "./download_file_link_controller"
application.register("download-file-link", DownloadFileLinkController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DutyShiftCalendarController from "./duty_shift_calendar_controller"
application.register("duty-shift-calendar", DutyShiftCalendarController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import FileShowController from "./file_show_controller"
application.register("file-show", FileShowController)

import FileUploadFormController from "./file_upload_form_controller"
application.register("file-upload-form", FileUploadFormController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FilterSummaryController from "./filter_summary_controller"
application.register("filter-summary", FilterSummaryController)

import FormController from "./form_controller"
application.register("form", FormController)

import FractionInputSvelteController from "./fraction_input_svelte_controller"
application.register("fraction-input-svelte", FractionInputSvelteController)

import GlobalSearchController from "./global_search_controller"
application.register("global-search", GlobalSearchController)

import GlobalSearchSvelteController from "./global_search_svelte_controller"
application.register("global-search-svelte", GlobalSearchSvelteController)

import InvoiceBillsController from "./invoice_bills_controller"
application.register("invoice-bills", InvoiceBillsController)

import InvoicePrintController from "./invoice_print_controller"
application.register("invoice-print", InvoicePrintController)

import ItemSwapController from "./item_swap_controller"
application.register("item-swap", ItemSwapController)

import ItinerariesController from "./itineraries_controller"
application.register("itineraries", ItinerariesController)

import MenuItemController from "./menu_item_controller"
application.register("menu-item", MenuItemController)

import MessageRecipientsController from "./message_recipients_controller"
application.register("message-recipients", MessageRecipientsController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavigationSectionController from "./navigation_section_controller"
application.register("navigation-section", NavigationSectionController)

import NewMessageController from "./new_message_controller"
application.register("new-message", NewMessageController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import OrganisationLookupController from "./organisation_lookup_controller"
application.register("organisation-lookup", OrganisationLookupController)

import PaginationController from "./pagination_controller"
application.register("pagination", PaginationController)

import PasswordInputController from "./password_input_controller"
application.register("password-input", PasswordInputController)

import PaymentFormController from "./payment_form_controller"
application.register("payment-form", PaymentFormController)

import RichTextPlaceholdersController from "./rich_text_placeholders_controller"
application.register("rich-text-placeholders", RichTextPlaceholdersController)

import PhoneInputController from "./phone_input_controller"
application.register("phone-input", PhoneInputController)

import PresenceAssignmentController from "./presence_assignment_controller"
application.register("presence-assignment", PresenceAssignmentController)

import PresenceCalendarController from "./presence_calendar_controller"
application.register("presence-calendar", PresenceCalendarController)

import PresenceCalendarSvelteController from "./presence_calendar_svelte_controller"
application.register("presence-calendar-svelte", PresenceCalendarSvelteController)

import PresenceSelectionController from "./presence_selection_controller"
application.register("presence-selection", PresenceSelectionController)

import PriceChangeController from "./price_change_controller"
application.register("price-change", PriceChangeController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import ProductItemFormController from "./product_item_form_controller"
application.register("product-item-form", ProductItemFormController)

import ProductImportFormController from "./product_import_form_controller"
application.register("product-import-form", ProductImportFormController)

import ProductItemsController from "./product_items_controller"
application.register("product-items", ProductItemsController)

import ProductsController from "./products_controller"
application.register("products", ProductsController)

import RecordPresenceController from "./record_presence_controller"
application.register("record-presence", RecordPresenceController)

import RefreshController from "./refresh_controller"
application.register("refresh", RefreshController)

import ReloadFrameController from "./reload_frame_controller"
application.register("reload-frame", ReloadFrameController)

import RemoveController from "./remove_controller"
application.register("remove", RemoveController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import ResourceSelectController from "./resource_select_controller"
application.register("resource-select", ResourceSelectController)

import SelectChangeController from "./select_change_controller"
application.register("select-change", SelectChangeController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SendInvoicesSvelteController from "./send_invoices_svelte_controller"
application.register("send-invoices-svelte", SendInvoicesSvelteController)

import ReminderableInvoicesSvelteController from "./reminderable_invoices_svelte_controller"
application.register("reminderable-invoices-svelte", ReminderableInvoicesSvelteController)

import ExcludedClientsSvelteController from "./excluded_clients_svelte_controller"
application.register("excluded-clients-svelte", ExcludedClientsSvelteController)

import ClinicRemindersToggleSvelteController from "./clinic_reminders_toggle_svelte_controller"
application.register("clinic-reminders-toggle-svelte", ClinicRemindersToggleSvelteController)

import SiteController from "./site_controller"
application.register("site", SiteController)

import SpeciesBreedsController from "./species_breeds_controller"
application.register("species-breeds", SpeciesBreedsController)

import SubmitLockController from "./submit_lock_controller"
application.register("submit-lock", SubmitLockController)

import TableController from "./table_controller"
application.register("table", TableController)

import TaskRowController from "./task_row_controller"
application.register("task-row", TaskRowController)

import TasksController from "./tasks_controller"
application.register("tasks", TasksController)

import ToggleElementController from "./toggle_element_controller"
application.register("toggle-element", ToggleElementController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import UserFormController from "./user_form_controller"
application.register("user-form", UserFormController)

import UserHistoryController from "./user_history_controller"
application.register("user-history", UserHistoryController)

import UserOnlyController from "./user_only_controller"
application.register("user-only", UserOnlyController)

import UserPresenceController from "./user_presence_controller"
application.register("user-presence", UserPresenceController)

import UserSessionController from "./user_session_controller"
application.register("user-session", UserSessionController)

import WaitingRoomController from "./waiting_room_controller"
application.register("waiting-room", WaitingRoomController)

import WarningMessageController from "./warning_message_controller"
application.register("warning-message", WarningMessageController)

import WeightsBlockController from "./weights_block_controller"
application.register("weights-block", WeightsBlockController)
